import { render } from "./CardListadoFicheros2.vue?vue&type=template&id=001f180e&scoped=true"
import script from "./CardListadoFicheros2.vue?vue&type=script&lang=js"
export * from "./CardListadoFicheros2.vue?vue&type=script&lang=js"

import "./CardListadoFicheros2.vue?vue&type=style&index=0&id=001f180e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001f180e"]])

export default __exports__